var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"shelf-id"},[_vm._v(_vm._s(_vm.label.substr(0,2)))]),_c('span',{staticClass:"space-id",class:("space-id--" + (_vm.label.substr(2,1)))},[_vm._v(_vm._s(_vm.label.substr(2,2)))])])}
var staticRenderFns = []

export { render, staticRenderFns }